import { LayoutNote, PaywallNote } from './constants/campaign-notes';
import {
  WebCoinsPlanType,
  WebSubscriptionPlanType,
} from './modules/subscriptions';

export type RegistrationPlatformType = 'web' | 'web_lure';

export const REGISTRATION_PLATFORM = {
  WEB: 'web' as const,
  WEBAPP_LURE: 'web_lure' as const,
} as const;

export type WebCampaignKeyType =
  | 'devmode'
  | 'MyCkd1'
  | 'MyCkd1NA'
  | 'Fy8m4P1'
  | 'g34bjed'
  | 'g34bjedTG'
  | 'g34bjedTT1'
  | 'g34bjedd'
  | 'g34bjeddBR1'
  | 'g34bjeddBR2'
  | 'g34bjeddLCY'
  | 'g34bjedWA'
  | 'g34FsGrAITl'
  | 'g34FsGrFlAI'
  | 'g34FsGrAIPh'
  | 'g34bjedICaTO'
  | 'g34bjedICaEm'
  | 'g34bjedICbEm'
  | 'g34bjedHcDrw'
  | 'g34bjedThScN'
  | 'g34bjedMn'
  | 'g34bjedMnCe'
  | 'g34bjedMn_FLs'
  | 'g34bjedMnScS'
  | 'g34bjedMnSPaE'
  | 'g34bjedMnSPaN'
  | 'g34bjedMnLSaN'
  | 'g34bjedMnLS'
  | 'g34bjedMnNf'
  | 'g34bjedMnWV'
  | 'g34bjedMnICbEm'
  | 'g34bjedMnICaEm'
  | 'g34bjedMnICaTO'
  | 'g34bjedMnPc'
  | 'g34bjedMnPTm'
  | 'g34bjedMnPTm9_19'
  | 'g34bjedMnPTmg3'
  | 'g34bjedMnPTmg5'
  | 'g34bjedMnPTmg6'
  | 'g34bjedMnPTmg9'
  | 'g34bjedMnPTmg12'
  | 'g34bjedMnPTmg15'
  | 'g34bjedMnPTm_FlsWTg'
  | 'g34bjedMnPTm_FlsWMg'
  | 'g34bjedMnPSt'
  | 'g34bjedMnPoff'
  | 'g34bjedSxPAp'
  | 'g34bjedSxFll'
  | 'g34bjedPoff'
  | 'g34bjedChSet'
  | 'g34bjedSx'
  | 'g34bjedSx9_19'
  | 'g34bjedSxB1'
  | 'g34bjedSxB3'
  | 'g34bjedSxO2'
  | 'g34bjedSxX1'
  | 'g34bjedSxWV'
  | 'g34bjedPlD'
  | 'g34bjedPS'
  | 'g34bjedPA'
  | 'g34bjedPAp'
  | 'g34bjedPApFT'
  | 'g34bjedSrOb'
  | 'g34dMGons'
  | 'g34dMGonsP9'
  | 'g34dMGonsP14'
  | 'g34dMGonsP19'
  | 'g34bjedMG'
  | 'g34bjedMG8_17'
  | 'g34bjedMG11_23'
  | 'g34bjedMGons14'
  | 'g34bjedMGwopay'
  | 'g34bjedMGweb_rd'
  | 'g34bjedMGv1'
  | 'g34bjedMGv2'
  | 'g34bjedMGsf'
  | 'g34bjedMGwwc'
  | 'g34bjedMGwwc_9_19'
  | 'g34bjedMGwwc_11_23'
  | 'g34bjedMGrp'
  | 'g34bjedMGrpW11_23'
  | 'g34bjedMGrpS'
  | 'Tg34bjedMGrp'
  | 'g34bjedMGrpM29_59'
  | 'g34bjedMGrpM29_39'
  | 'g34bjedMGrpM29_39e'
  | 'g34bjedMGrpM29_39t'
  | 'g34bjedMGrpWY'
  | 'g34bjedMGrp8_17'
  | 'g34bjedMGrp_aio'
  | 'g34bjedMGrp_aio_G'
  | 'g34bjedMGrp_aio_3'
  | 'g34bjedMGrp_aio_k'
  | 'g34bjedMGrp_aio_k_shy'
  | 'g34bjedMGrp_aio_k_shy_w'
  | 'g34bjedMGrp11_23'
  | 'g34bjedMGrp11_23TT_HM'
  | 'g34bjedMGrp11_23_ow'
  | 'g34bjedMGrp11_23_web'
  | 'g34bjedMGrp11_23_t'
  | 'g34bjedMGrp11_23_k'
  | 'g34bjedMGrp14_29'
  | 'g34bjedMGrpons14'
  | 'g34bjedMGrpa'
  | 'g34bjedMGrpam11_23'
  | 'g34bjedMGrpa9_19'
  | 'g34bjedMGrpan9_19'
  | 'g34bjedMGrp9_19'
  | 'g34bjedMGrp9_19test'
  | 'g34bjedMGrp9_19A'
  | 'g34bjedMGrp9_19B'
  | 'g34bjedMGrp9_19TT'
  | 'g34bjedMGrp9_21'
  | 'g34bjedMGan'
  | 'g34bjedMGnw'
  | 'g34bjedMGPPC1'
  | 'g34bjedMGPPC2'
  | 'g34bjedMG9_19'
  | 'g34bjedMG9_19TT'
  | 'g34bjedMG9_19_ow'
  | 'g34bjedMG9_19_fm'
  | 'g34bjedMG9_19_fm_G'
  | 'g34bjedMG9_19_fm_bG'
  | 'g34bjedMG9_19test'
  | 'g34bjedMG9_19g2'
  | 'g34bjedMG9_19g4'
  | 'g34bjedMG9_19g5'
  | 'g34bjedMG9_19p'
  | 'g34bjedMG9_21'
  | 'kfpn6v'
  | 'm8xq2p'
  | 'mftde9'
  | 'g34bjedMGUPS'
  | 'g34bjedMGUv1'
  | 'g34bjedMGUv2'
  | 'g34bjedMGUv3'
  | 'g34bjedMG11_23Uv1'
  | 'g34bjedMG11_23Uv2'
  | 'g34bjedMG11_23Uv3'
  | 'g34bjedMGrp11_23Uv1'
  | 'g34bjedMGrp11_23Uv2'
  | 'g34bjedMGrp11_23Uv3'
  | 'q22mnbvc'
  | 'q22mnbvcPhVi'
  | 'q22mnbvcPE'
  | 'q22mnAof'
  | 'q22mnbPoff'
  | 'ErpMn1'
  | 'ErpMn2'
  | 'ErpMn3'
  | 'ErpMn4'
  | 'ErpMn5'
  | 'ErpMn6'
  | 'ErpMn6NAP'
  | 'GfwtpsL'
  | 'GfwtpsS'
  | 'CmpbTb'
  | 'CmpbTbrp'
  | 'RpLRm'
  | 'Applvn'
  | 'Maxim'
  | 'LAg34bjedMGrp11_23'
  | 'LAppg34bjedMGrp11_23'
  | 'Maxim11_23'
  | 'Thomas11_23'
  | 'OnbPool'
  | 'Frst11_23'
  | 'Frst9_19';

export interface WebCampaignType {
  layout:
    | 'devmode'
    | 'default'
    | 'weekly-subscription'
    | 'v2-on-v1'
    | 'v2-on-v1-weekly'
    | 'replika-short'
    | 'replika-short-no-ai'
    | 'replika-relationships'
    | 'replika-short-v2'
    | 'replika-user-data-relationships'
    | 'replika-personalized'
    | 'own-ai'
    | 'own-ai-trans'
    | 'own-ai-w'
    | 'own-ai-ons'
    | 'own-ai-domination'
    | 'own-ai-domination-v2'
    | 'own-ai-FsGrAITl'
    | 'own-ai-FsGrFlAI'
    | 'own-ai-FsGrAIPh'
    | 'own-ai-ICaEm'
    | 'own-ai-ICbEm'
    | 'own-ai-pool'
    | 'own-ai-ICaTO'
    | 'own-ai-man'
    | 'own-ai-man-trans-l'
    | 'own-ai-man-trans-s'
    | 'own-ai-man-g'
    | 'own-ai-man-ce'
    | 'own-ai-man-fls'
    | 'own-ai-man-fls-tg'
    | 'own-ai-man-fls-mg'
    | 'own-ai-man-scs'
    | 'own-ai-man-SPaE'
    | 'own-ai-man-SPaN'
    | 'own-ai-man-LSaN'
    | 'own-ai-man-ls'
    | 'own-ai-man-ICbEm'
    | 'own-ai-man-ICaEm'
    | 'own-ai-man-ICaTO'
    | 'own-ai-man-paymentless'
    | 'own-ai-paymentless'
    | 'own-ai-second'
    | 'own-ai-second-video'
    | 'own-ai-multigender'
    | 'own-ai-multigender-safe'
    | 'own-ai-multigender-safe-v2'
    | 'own-ai-constructor'
    | 'own-ai-compatibility'
    | 'own-ai-man-roleplay'
    | 'own-ai-man-roleplay-nap'
    | 'own-ai-roleplay-rooms'
    | 'own-ai-man-maxim'
    | 'own-ai-man-tm'
    | 'own-ai-multigender-forest'
    | 'own-ai-multigender-lure'
    | 'own-ai-multigender-fm'
    | 'own-ai-multigender-fm-g'
    | 'own-ai-multigender-fm-bg'
    | 'own-ai-multigender-aio-g';
  layoutNotes: LayoutNote[];
  preferencesVariant: 'default' | 'v1' | 'v2' | 'v3';
  theme: 'dark' | 'light';
  paywall:
    | 'devmode'
    | 'v1'
    | 'v2'
    | 'v6'
    | 'default-short'
    | 'fast-pay-tabs'
    | 'fast-pay-tabs-domination'
    | 'fast-pay-tabs-roleplay'
    | 'fast-pay-tabs-man'
    | 'fast-pay-tabs-multigender'
    | null;
  paywallNotes: PaywallNote[];
  paywallImagesVariant:
    | 'v6'
    | 'v6-sexy'
    | 'skinny_regular_on_bed'
    | 'fast-pay-tabs-man'
    | 'main-697'
    | 'one-night-stand'
    | 'one-night-stand-constructor'
    | 'multigender'
    | 'transsexual'
    | null;
  ai_type: 'girl' | 'old_women' | 'gay' | 'furry' | 'legs';
  gender_ai_type: 'women' | 'man';
  plans: WebSubscriptionPlanType[];
  /** For multigender: explicit plans per gender (Male = 11_23, Female = 9_19 etc.) */
  plansByGender?: {
    male: WebSubscriptionPlanType[];
    female: WebSubscriptionPlanType[];
  };
  coins: WebCoinsPlanType[];
  defaultPlan: WebCampaignType['plans'][number];
  animated: boolean;
  staticTheme: 'dark-violet' | 'domination' | 'purple-gradient' | null;
  successPage:
    | 'devmode'
    | 'default'
    | 'default-upsale'
    | 'onboarding-based'
    | 'with-email'
    | 'paymentless'
    | 'domination'
    | 'roleplay'
    | 'one-night-stand'
    | 'one-night-stand-constructor'
    | 'one-night-stand-man'
    | 'multigender'
    | 'multigender-web'
    | 'multigender-only-web'
    | 'multigender-aio'
    | 'trans'
    | 'web-version'
    | 'maxim'
    | 'with-steps'
    | 'with-steps-web';
  hasNameAfterPaywall: boolean;
  postPaywallName: 'roleplay' | null;
  hasDisabledWeeklyPlan: boolean;
  canLogFBEvents: boolean;
  rejectPrepaidCards: boolean;
  task: string | null;
  comment: string | null;
  hasWebAppLink: boolean;
  redirectToWebappAfter: null | 'email' | 'subscription';
  enableAxonTracking?: boolean;
  registrationPlatform?: RegistrationPlatformType;
}
